import React, { useState } from "react";

const ButtonTab = ({updateCountdownTimerTabData,countdownTimerTabData}) => {
    const [showButton, setShowButton] = useState(Number(countdownTimerTabData.button_is_show_button));
    const [showButtonLink, setShowButtonLink] = useState(countdownTimerTabData.button_link);
    const [showButtonText, setShowButtonText] = useState(countdownTimerTabData.button_text);
    const [buttonOpenLinkinNewTab, setButtonOpenLinkinNewTab] = useState(Number(countdownTimerTabData.button_is_open_link_in_new_tab));

    // Handlers Show Button Change
    const handleShowButtonChange = (e) => {
        const checked = e.target.checked;
        setShowButton(checked);
        updateCountdownTimerTabData("button_is_show_button", checked); 
    };

    // Handlers Show Button Link Change
    const handleShowButtonLinkChange = (e) => {
        const value = e.target.value;
        setShowButtonLink(value);
        updateCountdownTimerTabData("button_link", value); 
    };

    // Handlers Show Button Text Change
    const handleShowButtonTextChange = (e) => {
        const value = e.target.value;
        setShowButtonText(value);
        updateCountdownTimerTabData("button_text", value); 
    };

    // Handlers Open The Link In A New Tab Change
    const handlButtonOpenLinkinNewTabChange = (e) => {
        const checked = e.target.checked;
        setButtonOpenLinkinNewTab(checked);
        updateCountdownTimerTabData("button_is_open_link_in_new_tab", checked); 
    };

    return (
        <div className="countdown-timer-side-baar-button-tab">
            <span>Button</span>
            <div className="side-baar-box-header">
                <div className="box-header-row last-border-none">
                    <span>Show Button</span>
                    <div className="form-group">
                        <input id="setting_open_link_in_new_tab_toggle" className="chkbx-toggle" type="checkbox" checked={showButton} onChange={handleShowButtonChange}/>
                        <label for="setting_open_link_in_new_tab_toggle"></label>
                    </div>
                </div>
            </div>
            {Number(countdownTimerTabData.button_is_show_button) === 1 && (
            <>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <h6 className="h6-tage">Button Link</h6>
                    <input className="timer-input-link" type="text" value={showButtonLink} onChange={handleShowButtonLinkChange}/>
                </div>
                <div className="box-header-row">
                    <h6 className="h6-tage">Button Text</h6>
                    <input className="timer-input-link" type="text" value={showButtonText} onChange={handleShowButtonTextChange} />
                </div>
                <div className="box-header-row">
                    <span>Open The Link In A New Tab</span>
                    <div className="form-group">
                        <input id="open_link_in_new_tab_toggle" className="chkbx-toggle" type="checkbox" checked={buttonOpenLinkinNewTab} onChange={handlButtonOpenLinkinNewTabChange} />
                        <label for="open_link_in_new_tab_toggle"></label>
                    </div>
                </div>
                {/*<div className="box-header-row last-border-none">
                    <span>Make The Whole Timer Clickable</span>
                    <div className="form-group">
                        <input id="make_the_whole_timer_toggle" className="chkbx-toggle" type="checkbox" value="1" />
                        <label for="make_the_whole_timer_toggle"></label>
                    </div>
                </div>*/}
            </div>
            </>
            )}
        </div>
    );
};

export default ButtonTab;